/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomComponentLibrariesGet200Response,
  CustomComponentLibrariesLibraryIdGet200Response,
  CustomComponentLibrariesLibraryIdRevisionsGet200Response,
  CustomComponentLibrariesLibraryIdRevisionsPost200Response,
  CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response,
  CustomComponentLibrariesPost200Response,
  CustomComponentLibrariesPostRequest,
} from '../models/index';
import {
    CustomComponentLibrariesGet200ResponseFromJSON,
    CustomComponentLibrariesGet200ResponseToJSON,
    CustomComponentLibrariesLibraryIdGet200ResponseFromJSON,
    CustomComponentLibrariesLibraryIdGet200ResponseToJSON,
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseFromJSON,
    CustomComponentLibrariesLibraryIdRevisionsGet200ResponseToJSON,
    CustomComponentLibrariesLibraryIdRevisionsPost200ResponseFromJSON,
    CustomComponentLibrariesLibraryIdRevisionsPost200ResponseToJSON,
    CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseFromJSON,
    CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseToJSON,
    CustomComponentLibrariesPost200ResponseFromJSON,
    CustomComponentLibrariesPost200ResponseToJSON,
    CustomComponentLibrariesPostRequestFromJSON,
    CustomComponentLibrariesPostRequestToJSON,
} from '../models/index';

export interface CustomComponentLibrariesGetRequest {
    nextToken?: string;
}

export interface CustomComponentLibrariesLibraryIdGetRequest {
    libraryId: string;
}

export interface CustomComponentLibrariesLibraryIdRevisionsGetRequest {
    libraryId: string;
}

export interface CustomComponentLibrariesLibraryIdRevisionsPostRequest {
    libraryId: string;
    versionBump: CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum;
    files: Blob;
    id?: string;
    version?: string;
}

export interface CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGetRequest {
    libraryId: string;
    revisionId: string;
}

export interface CustomComponentLibrariesPostOperationRequest {
    customComponentLibrariesPostRequest?: CustomComponentLibrariesPostRequest;
}

/**
 * 
 */
export class CustomComponentLibraryApi extends runtime.BaseAPI {

    /**
     * Available from API version 2.4.0+ and onprem version 3.32.0+. Gets a paginated list of all custom component libraries. The API token must have the \"CustomComponent > Read\" scope.
     * Get a list of all custom component libraries
     */
    async customComponentLibrariesGetRaw(requestParameters: CustomComponentLibrariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomComponentLibrariesGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters.nextToken !== undefined) {
            queryParameters['next_token'] = requestParameters.nextToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/custom_component_libraries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomComponentLibrariesGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.32.0+. Gets a paginated list of all custom component libraries. The API token must have the \"CustomComponent > Read\" scope.
     * Get a list of all custom component libraries
     */
    async customComponentLibrariesGet(requestParameters: CustomComponentLibrariesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomComponentLibrariesGet200Response> {
        const response = await this.customComponentLibrariesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.34.0+. Gets a single custom component library. The API token must have the \"CustomComponent > Read\" scope.
     * Get a single custom component libraries
     */
    async customComponentLibrariesLibraryIdGetRaw(requestParameters: CustomComponentLibrariesLibraryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomComponentLibrariesLibraryIdGet200Response>> {
        if (requestParameters.libraryId === null || requestParameters.libraryId === undefined) {
            throw new runtime.RequiredError('libraryId','Required parameter requestParameters.libraryId was null or undefined when calling customComponentLibrariesLibraryIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/custom_component_libraries/{libraryId}`.replace(`{${"libraryId"}}`, encodeURIComponent(String(requestParameters.libraryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomComponentLibrariesLibraryIdGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.34.0+. Gets a single custom component library. The API token must have the \"CustomComponent > Read\" scope.
     * Get a single custom component libraries
     */
    async customComponentLibrariesLibraryIdGet(requestParameters: CustomComponentLibrariesLibraryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomComponentLibrariesLibraryIdGet200Response> {
        const response = await this.customComponentLibrariesLibraryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.34.0+. Gets a list of all the revisions of a custom component library. The API token must have the \"CustomComponent > Read\" scope.
     * Gets a list of all the revisions of a custom component library
     */
    async customComponentLibrariesLibraryIdRevisionsGetRaw(requestParameters: CustomComponentLibrariesLibraryIdRevisionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomComponentLibrariesLibraryIdRevisionsGet200Response>> {
        if (requestParameters.libraryId === null || requestParameters.libraryId === undefined) {
            throw new runtime.RequiredError('libraryId','Required parameter requestParameters.libraryId was null or undefined when calling customComponentLibrariesLibraryIdRevisionsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/custom_component_libraries/{libraryId}/revisions`.replace(`{${"libraryId"}}`, encodeURIComponent(String(requestParameters.libraryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomComponentLibrariesLibraryIdRevisionsGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.34.0+. Gets a list of all the revisions of a custom component library. The API token must have the \"CustomComponent > Read\" scope.
     * Gets a list of all the revisions of a custom component library
     */
    async customComponentLibrariesLibraryIdRevisionsGet(requestParameters: CustomComponentLibrariesLibraryIdRevisionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomComponentLibrariesLibraryIdRevisionsGet200Response> {
        const response = await this.customComponentLibrariesLibraryIdRevisionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.32.0+. Creates a new version of a custom component library, the underlying files that describe the component. The API token must have the \"CustomComponent > Write\" scope.
     * Create a new custom component library revision
     */
    async customComponentLibrariesLibraryIdRevisionsPostRaw(requestParameters: CustomComponentLibrariesLibraryIdRevisionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomComponentLibrariesLibraryIdRevisionsPost200Response>> {
        if (requestParameters.libraryId === null || requestParameters.libraryId === undefined) {
            throw new runtime.RequiredError('libraryId','Required parameter requestParameters.libraryId was null or undefined when calling customComponentLibrariesLibraryIdRevisionsPost.');
        }

        if (requestParameters.versionBump === null || requestParameters.versionBump === undefined) {
            throw new runtime.RequiredError('versionBump','Required parameter requestParameters.versionBump was null or undefined when calling customComponentLibrariesLibraryIdRevisionsPost.');
        }

        if (requestParameters.files === null || requestParameters.files === undefined) {
            throw new runtime.RequiredError('files','Required parameter requestParameters.files was null or undefined when calling customComponentLibrariesLibraryIdRevisionsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.id !== undefined) {
            formParams.append('id', requestParameters.id as any);
        }

        if (requestParameters.versionBump !== undefined) {
            formParams.append('version_bump', requestParameters.versionBump as any);
        }

        if (requestParameters.version !== undefined) {
            formParams.append('version', requestParameters.version as any);
        }

        if (requestParameters.files !== undefined) {
            formParams.append('files', requestParameters.files as any);
        }

        const response = await this.request({
            path: `/custom_component_libraries/{libraryId}/revisions`.replace(`{${"libraryId"}}`, encodeURIComponent(String(requestParameters.libraryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomComponentLibrariesLibraryIdRevisionsPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.32.0+. Creates a new version of a custom component library, the underlying files that describe the component. The API token must have the \"CustomComponent > Write\" scope.
     * Create a new custom component library revision
     */
    async customComponentLibrariesLibraryIdRevisionsPost(requestParameters: CustomComponentLibrariesLibraryIdRevisionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomComponentLibrariesLibraryIdRevisionsPost200Response> {
        const response = await this.customComponentLibrariesLibraryIdRevisionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.37.0+. Gets all files associated with a custom component library revision. The API token must have the \"CustomComponent > Read\" scope.
     * Gets all files associated with a custom component library revision.
     */
    async customComponentLibrariesLibraryIdRevisionsRevisionIdFilesGetRaw(requestParameters: CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response>> {
        if (requestParameters.libraryId === null || requestParameters.libraryId === undefined) {
            throw new runtime.RequiredError('libraryId','Required parameter requestParameters.libraryId was null or undefined when calling customComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet.');
        }

        if (requestParameters.revisionId === null || requestParameters.revisionId === undefined) {
            throw new runtime.RequiredError('revisionId','Required parameter requestParameters.revisionId was null or undefined when calling customComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/custom_component_libraries/{libraryId}/revisions/{revisionId}/files`.replace(`{${"libraryId"}}`, encodeURIComponent(String(requestParameters.libraryId))).replace(`{${"revisionId"}}`, encodeURIComponent(String(requestParameters.revisionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.37.0+. Gets all files associated with a custom component library revision. The API token must have the \"CustomComponent > Read\" scope.
     * Gets all files associated with a custom component library revision.
     */
    async customComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet(requestParameters: CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response> {
        const response = await this.customComponentLibrariesLibraryIdRevisionsRevisionIdFilesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.32.0+. Creates a new custom component library The API token must have the \"CustomComponent > Write\" scope.
     * Create a new custom component library
     */
    async customComponentLibrariesPostRaw(requestParameters: CustomComponentLibrariesPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomComponentLibrariesPost200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/custom_component_libraries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomComponentLibrariesPostRequestToJSON(requestParameters.customComponentLibrariesPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomComponentLibrariesPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Available from API version 2.4.0+ and onprem version 3.32.0+. Creates a new custom component library The API token must have the \"CustomComponent > Write\" scope.
     * Create a new custom component library
     */
    async customComponentLibrariesPost(requestParameters: CustomComponentLibrariesPostOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomComponentLibrariesPost200Response> {
        const response = await this.customComponentLibrariesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum = {
    Minor: 'minor',
    Major: 'major',
    Dev: 'dev',
    SpecifyVersion: 'specify_version'
} as const;
export type CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum = typeof CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum[keyof typeof CustomComponentLibrariesLibraryIdRevisionsPostVersionBumpEnum];
